import { render } from "./lhbd.vue?vue&type=template&id=6fb08ff1&scoped=true&ts=true"
import script from "./lhbd.vue?vue&type=script&lang=ts"
export * from "./lhbd.vue?vue&type=script&lang=ts"

import "./lhbd.vue?vue&type=style&index=0&id=6fb08ff1&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb08ff1"]])

export default __exports__